import { UPDATE_BOOKINGS } from "./types";

const updateBookings = (bookings) => ({
  type: UPDATE_BOOKINGS,
  bookings,
});

export default updateBookings;
